import React from 'react'

export type SelectContextType = {
  leftAddon?: string | JSX.Element
}
export const SelectContext = React.createContext<SelectContextType>(
  null as unknown as SelectContextType
)
